module.exports = __webpack_public_path__ + "img/nut-2.4ccaef49.svg";